import React from "react";
import { siteColors } from "../variables/colors";
import linkedin from "../img/social/linkedIn.svg";
import instagram from "../img/social/instagram.svg";
import logo from "../img/elsa-logo.png";

const Navbar = () => {
  return (
    <div>
      <nav
        className="navbar nav-top
        "
        style={{
          backgroundColor: siteColors.cyan,
        }}
      >
        <div className="social-media-nav-icons">
          <a title="instagram" href="https://instagram.com">
            <img
              src={instagram}
              alt="Instagram"
              style={{ width: "24px", height: "24px" }}
            />
          </a>
          <a title="linkedin" href="https://linkedin.com">
            <img
              src={linkedin}
              alt="linkedin"
              style={{ width: "24px", height: "24px" }}
            />
          </a>
        </div>
        <div className="nav-contact">
          <a className="navlink">Jane@elsa.education | </a>
          <a className="navlink">07745 585702</a>
        </div>
      </nav>
    </div>
  );
};

export default Navbar;
